import FullHeightContainerLayout from "components/atoms/FullHeightContainerLayout";
import DataObjectShared from "containers/DataObjectShared";

const SharedDataObject = (props) => {
    return <FullHeightContainerLayout showHeader={false} showFooter={false} content={<DataObjectShared {...props}></DataObjectShared>}></FullHeightContainerLayout>;
};

export default SharedDataObject;
